import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

import Home from "./pages/Home";
import About from "./pages/About";
import Courses from "./pages/Courses";
import Team from "./pages/Team";
import Contact from "./pages/Contact";
import Ouriti from "./pages/Ouriti";
import WhyWe from "./pages/WhyWe";
import Login from "./pages/login";
import Dashboard from "./admin/Dashboard";
import VisionMission from "./pages/VisionMission";
import History from "./pages/History";
import Gallery from "./pages/Gallery";
import Infrastructure from "./pages/Infrastructure";
import CoursesOffered from "./pages/CoursesOffered";
import StaffDetails from "./pages/StaffDetails";
import Admission from "./pages/Admission";
import Notification from "./pages/Notification";
import ProjectUpload from "./admin/ProjectUpload";
import ProjectDisplay from "./pages/ProjectDisplay";
import StudentDetails from "./admin/StudentDetails";
import Staff from "./admin/Staff";
import TradeManagement from "./admin/TradeManagement";
import StudentNotifications from "./admin/StudentNotifications";
import BonafideCertificate from "./admin/BonafideCertificate";
import ContactMessages from "./admin/ContactMessages";
import FeeDetails from "./admin/FeeDetails";
import ProtectedRoute from "./components/ProtectedRoute";
import LetterheadDocuments from "./admin/LetterheadDocuments";

// ✅ Layout Wrapper
function AppContent() {
  const location = useLocation();

  // Hide layout for login and dashboard routes
  const hideLayout =
    location.pathname === "/login"  || location.pathname === "/studentdetails" || location.pathname === "/dashboard"
     || location.pathname === "/staff" || location.pathname === "/trades" || location.pathname === "/StudentNotifications"
      || location.pathname === "/BonafideCertificate" || location.pathname === "/FeeDetails" || location.pathname === "/ContactMessages"
      || location.pathname === "/ProjectUpload"|| location.pathname === "/LetterheadDocuments";
  return (
    <>
      {!hideLayout && <Navbar />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/ouriti" element={<Ouriti />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/team" element={<Team />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/whywe" element={<WhyWe />} />
        <Route path="/login" element={<Login />} />

        <Route path="/visionmission" element={<VisionMission />} />
        <Route path="/history" element={<History />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/infrastructure" element={<Infrastructure />} />
        <Route path="/coursesoffered" element={<CoursesOffered />} />
        <Route path="/staffdetails" element={<StaffDetails />} />
        <Route path="/admission" element={<Admission />} />
        <Route path="/notification" element={<Notification />} />

        <Route path="/projectdisplay" element={<ProjectDisplay />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/studentdetails"
          element={
            <ProtectedRoute>
              <StudentDetails />
            </ProtectedRoute>
          }
        />

        <Route
          path="/staff"
          element={
            <ProtectedRoute>
              <Staff />
            </ProtectedRoute>
          }
        />

        <Route
          path="/trades"
          element={
            <ProtectedRoute>
              <TradeManagement />
            </ProtectedRoute>
          }
        />

        <Route
          path="/StudentNotifications"
          element={
            <ProtectedRoute>
              <StudentNotifications />
            </ProtectedRoute>
          }
        />

        <Route
          path="/BonafideCertificate"
          element={
            <ProtectedRoute>
              <BonafideCertificate />
            </ProtectedRoute>
          }
        />

        <Route
          path="/FeeDetails"
          element={
            <ProtectedRoute>
              <FeeDetails />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ContactMessages"
          element={
            <ProtectedRoute>
              <ContactMessages />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ProjectUpload"
          element={
            <ProtectedRoute>
              <ProjectUpload />
            </ProtectedRoute>
          }
        />
        <Route path="/LetterheadDocuments" element={<ProtectedRoute><LetterheadDocuments /></ProtectedRoute>} />
      </Routes>
      

      {!hideLayout && <Footer />}
      {!hideLayout && <BackToTop />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
